import * as muStyles from "./styles/style.mu";
import * as mguStyles from "./styles/style.mgu";
import * as suStyles from "./styles/style.su";
import muTheme from "./themes/theme.mu";
import mguTheme from "./themes/theme.mgu";
import suTheme from "./themes/theme.su";
import { tenants } from "utils/tenants";
import theme from "./themes/theme.mu";
export const getGradeColor = grade => {
  if (!grade) return "inherit";

  const match = String(grade).match(/([\d]+[.,]?\d*)/);

  if (!match) return "inherit";

  const numeric = parseFloat(match[1].replace(",", "."));

  if (isNaN(numeric)) return "inherit";

  return numeric >= 2 && numeric < 3 ? theme.palette.error.primary : "black";
};

export const getStyle = tenant => {
  switch (tenant) {
    case tenants.MU:
      return muStyles;
    case tenants.MGU:
      return mguStyles;
    case tenants.SU:
      return suStyles;
    default:
      return muStyles;
  }
};

export const getTheme = tenant => {
  switch (tenant) {
    case tenants.MU:
      return muTheme;
    case tenants.MGU:
      return mguTheme;
    case tenants.SU:
      return suTheme;
    default:
      return muTheme;
  }
};
